import { issueMeta } from "@/mocks/home";

const footerColumns = [
  {
    id: "col-1",
    title: "合辑栏目",
    links: [
      { id: "f1", label: "爆料时间线", href: "#collections" },
      { id: "f2", label: "账号档案", href: "#collections" },
      { id: "f3", label: "直播切片渠道", href: "#collections" },
      { id: "f4", label: "旧事重提", href: "#collections" },
    ],
  },
  {
    id: "col-2",
    title: "快速导航",
    links: [
      { id: "f5", label: "合辑索引", href: "#collections" },
      { id: "f6", label: "账号与频道", href: "#channels" },
      { id: "f7", label: "观看路径", href: "#routes" },
      { id: "f8", label: "速查索引", href: "#index" },
    ],
  },
  {
    id: "col-3",
    title: "关于本站",
    links: [
      { id: "f9", label: "内容收录说明", href: "#" },
      { id: "f10", label: "更正与反馈", href: "#" },
      { id: "f11", label: "免责声明", href: "#" },
      { id: "f12", label: "更新日志", href: "#" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-950 text-background-100">
      <div className="mx-auto w-full max-w-[1360px] px-4 py-16 md:px-8 md:py-20">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-10">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-500 font-heading text-lg font-bold text-foreground-950">
                瓜
              </span>
              <span className="font-heading text-lg font-bold text-background-50">
                {issueMeta.brand}
              </span>
            </div>
            <p className="mt-6 max-w-md text-sm leading-relaxed text-background-100/75">
              一本把分散入口收拢起来的导航册：告诉你在哪儿看、由谁更新、先看哪一条。
              全部信息仅为公开入口的整理，不生产、不搬运原始素材。
            </p>
            <div className="mt-7 flex flex-wrap items-center gap-3 text-xs text-background-100/70">
              <span className="rounded-full border border-background-100/25 px-3 py-1">
                {issueMeta.issue}
              </span>
              <span className="rounded-full border border-background-100/25 px-3 py-1">
                每日整理
              </span>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-10 sm:grid-cols-3 lg:col-span-7 lg:gap-8">
            {footerColumns.map((column) => (
              <div key={column.id}>
                <h4 className="font-heading text-sm tracking-wider text-accent-300">
                  {column.title}
                </h4>
                <ul className="mt-5 space-y-3">
                  {column.links.map((link) => (
                    <li key={link.id}>
                      <a
                        href={link.href}
                        className="cursor-pointer text-sm text-background-100/75 transition-colors hover:text-background-50"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-4 border-t border-background-100/20 pt-8 text-xs text-background-100/65 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 {issueMeta.brand} · 导航合辑。内容均为公开信息整理，仅供参考。</p>
          <a
            href="#top"
            className="flex cursor-pointer items-center gap-2 whitespace-nowrap transition-colors hover:text-background-50"
          >
            回到顶部
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-arrow-up-line"></i>
            </span>
          </a>
        </div>
      </div>
    </footer>
  );
}